/* eslint-disable */
import React from 'react';
import headwinds from './headwinds.svg';

const Logo = props => {
  return (
        <a href="/" rel="home">
          {' '}
          <img src={headwinds} style={{width: 100}} />
        </a>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/nav/Logo.js